<wl-simple-progressive-form-card
  [progressiveFormState]="progressiveFormState()"
  [content]="progressiveFormCardContent()"
  [asyncSubmission]="true"
  [trackingConfig]="{
    toolName: rendering().componentName,
    step: stepNumber(),
    stepName: 'controleren',
  }"
>
  <ng-template #content>
    <div class="mb-3">
      <span
        *wlGenericRichText="orderContent().confirmationSummaryBefore"
      ></span>
      @if (orderContent().confirmationSummaryTooltip) {
        <wl-tooltip
          class="pe-1"
          [tooltip]="{
            description: orderContent().confirmationSummaryTooltip,
          }"
        ></wl-tooltip>
      }
      <span *wlGenericRichText="orderContent().confirmationSummaryAfter"></span>
    </div>
    @if (
      !orderContent().termsAndConditionsV2 ||
      orderContent().enableActionMailCheckbox ||
      orderContent().enableInformationMailCheckbox
    ) {
      <div class="row g-1">
        <div class="col-12">
          @if (!orderContent().termsAndConditionsV2) {
            <div class="mb-2">
              <ng-template
                [ngTemplateOutlet]="termsAndConditionsCheckbox"
              ></ng-template>
            </div>
          }
          <!-- ED/Essent ONLY -->
          @if (
            orderContent().termsAndConditionsV2 &&
            !orderContent().enableAutomaticEmailOptIn
          ) {
            <div>
              <p class="fw-bold">
                {{ orderContent().actionInformationMailFormGroupLabel }}
              </p>
            </div>
          }

          @if (orderContent().enableAutomaticEmailOptIn) {
            <!-- Automatic opt-in with ability to opt-out -->
            <div class="mb-4">
              @if (
                orderContent().consentsTextBefore.value &&
                orderContent().consentsTextLink &&
                orderContent().consentsTextAfter.value
              ) {
                <div class="mb-4">
                  <span *wlGenericRichText="orderContent().consentsTextBefore">
                  </span>
                  <button
                    (click)="openConsentsModal()"
                    class="btn btn-link p-0 align-baseline"
                  >
                    {{ orderContent().consentsTextLink }}
                  </button>
                  <span *wlGenericRichText="orderContent().consentsTextAfter">
                  </span>
                </div>

                @if (
                  phoneConsentValues().energyAdvice ||
                  phoneConsentValues().sustainability
                ) {
                  <wl-info-card
                    class="consents-card"
                    [title]="{ value: orderContent().consentsMessageTitle }"
                    [message]="{ value: phoneConsentMessage() }"
                    [hijackButton]="true"
                    [buttonText]="orderContent().consentsMessageButton"
                    [buttonType]="'button-outline'"
                    [backgroundGrey]="envConfig.brand === 'ed'"
                    [shadow]="envConfig.brand === 'essent'"
                    (buttonClick)="openConsentsModal()"
                  ></wl-info-card>
                }
              } @else if (orderContent().automaticEmailOptInText.value) {
                <div
                  class="d-inline me-1"
                  *wlGenericRichText="orderContent().automaticEmailOptInText"
                ></div>
              }
            </div>
          } @else {
            <!-- Manual opt-in -->
            <div class="mb-4">
              @if (
                orderContent().enableActionMailCheckbox ||
                orderContent().enableInformationMailCheckbox
              ) {
                <div>
                  <p class="fw-bold">{{ orderContent().emailConsentLabel }}</p>
                </div>
              }
              @if (orderContent().enableActionMailCheckbox) {
                <div class="mb-2">
                  <wl-checkbox
                    [rendering]="rendering()"
                    stepName="controleren"
                    [step]="stepNumber()"
                    fieldName="email aanbiedingen"
                    [formsControl]="formState().controls.actionMailAccepted"
                  >
                    {{ orderContent().actionMail }}
                  </wl-checkbox>
                </div>
              }
              @if (orderContent().enableInformationMailCheckbox) {
                <wl-checkbox
                  [rendering]="rendering()"
                  stepName="controleren"
                  [step]="stepNumber()"
                  fieldName="email nieuwsbrief"
                  [formsControl]="formState().controls.informationMailAccepted"
                >
                  {{ orderContent().informationMail }}
                </wl-checkbox>
              }
            </div>
          }
          <!-- /ED/Essent ONLY -->
        </div>
      </div>
    }
    @if (orderContent().commercialSummary.value) {
      <div class="mb-4">
        <div
          class="d-inline me-1"
          *wlGenericRichText="orderContent().commercialSummary"
        ></div>
        <wl-tooltip
          [tooltip]="{
            description: orderContent().commercialTooltip,
          }"
        ></wl-tooltip>
      </div>
    }
    @if (orderContent().termsAndConditionsV2) {
      <div class="terms-and-conditions-v2-container p-2 rounded">
        <p class="fw-bold">
          {{ orderContent().termsAndConditionsFormGroupLabel }}
        </p>
        <ng-template
          [ngTemplateOutlet]="termsAndConditionsCheckbox"
        ></ng-template>
      </div>
    }
  </ng-template>
  <ng-template #footnote>
    <div class="mt-2">
      {{ orderContent().confirmationLabelAfterSubmitButton }}
    </div>
  </ng-template>
</wl-simple-progressive-form-card>

<ng-template #termsAndConditionsCheckbox>
  <wl-checkbox
    [rendering]="rendering()"
    stepName="controleren"
    [step]="stepNumber()"
    fieldName="voorwaarden geaccepteerd"
    class="d-block"
    [class.mb-2]="formState().controls.conditionsAccepted | isValid"
    [formsControl]="formState().controls.conditionsAccepted"
  >
    <span wlAutomationId="orderFulfillment-confirm-checkbox-label">{{
      orderContent().acceptConditionsTextBefore
    }}</span>
    @for (disclaimer of disclaimers(); track $index; let i = $index) {
      <span>
        @if (disclaimer.href && disclaimer.key.value) {
          <a
            [href]="disclaimer.href"
            [wlAutomationId]="disclaimer.automationId"
            target="_blank"
            *scText="disclaimer.key"
          ></a>
          @if (i + 1 <= disclaimers().length - 1) {
            <span>, </span>
          }
        }
      </span>
    }
    {{ 'And' | translate }}
    @if (offer(); as offer) {
      <button
        (click)="openAOMModalClick($event)"
        class="tariffs-button btn btn-link p-0"
      >
        {{ 'Tarifs' | translate }}
      </button>
    }
    <span>{{ orderContent().acceptConditionsTextAfter }}</span>
    @if (offer()?.isDynamicProduct) {
      <span>{{ orderContent().acceptConditionsTextDynamicContract }}</span>
    }
  </wl-checkbox>
  @if (formState().controls.conditionsAccepted | isInvalid) {
    <div class="ms-6 mb-2">
      <wl-input-error
        wlAutomationId="conditions-accepted-required-error"
        [messageField]="orderContent().acceptConditionsRequiredError"
        messageDescription="voorwaarden geaccepteerd"
        [rendering]="rendering()"
        stepName="controleren"
        [step]="stepNumber()"
      ></wl-input-error>
    </div>
  }
</ng-template>
